import { Maatregel } from "@/entities/vsm";
import { createContext, useContext } from "react";

const noop = () => {};

export type MaatregelVariant = { variant: "view" } | { variant: "oud" } | { variant: "nieuw"; intent: "create" | "update" };

export type MaatregelContextActions = {
    startEdit: (maatregel: Maatregel) => void;
    save: (updatedMaatregel: Maatregel) => void;
    copyToNieuweVersie: (copy: Maatregel) => void;
    isCopiedToNieuweVersie: (maatregel: Maatregel) => boolean;
    cancel: (maatregelToCancel: Maatregel | null) => void;
    deleteMaatregel: (maatregelId: string) => void;
    acceptToelichting: (maatregelId: string) => void;
    removeToelichting: (maatregelId: string) => void;
};

export type MaatregelContextType = MaatregelVariant &
    MaatregelContextActions & {
        isEditEnabled: boolean;
    };

// Versperringsmaatregel expects a MaatregelContext, but some views (like vsm-details) do not support editing actions.
// For those cases, we provide a default context with no-op implementations.
export const maatregelContextDefaults: MaatregelContextType = {
    variant: "view",
    isEditEnabled: false,
    startEdit: noop,
    save: noop,
    cancel: noop,
    copyToNieuweVersie: noop,
    isCopiedToNieuweVersie: () => false,
    deleteMaatregel: noop,
    acceptToelichting: noop,
    removeToelichting: noop,
};

export const MaatregelContext = createContext<MaatregelContextType>(maatregelContextDefaults);

export const useMaatregelContext = (): MaatregelContextType => {
    return useContext(MaatregelContext);
};
